const messageKeys = [
  'GOT_TOTAL_SALE_AMOUNT',
  'SHOP_INVENTORY',
];

const messages: Record<ShopStoreMessage, ShopStoreMessage> = Object.fromEntries(
  messageKeys.map((k) => [k, k])
) as Record<ShopStoreMessage, ShopStoreMessage>;
export default messages;

export type ShopStoreMessage = (typeof messageKeys)[number];
